import React, { FunctionComponent } from 'react'
import styles from './PopupFilters.module.sass'
import { AnimatePresence, motion } from 'framer-motion'
import DateRangeInput from '../../../../../data-components/date/DateRangeInput/DateRangeInput'
import {DesignProductionFilters, RefLine} from '../filters'
import { ProjectFiltersState } from '../../../../../../redux/pages/project-list-filters'
import { apiRequests } from '../../../../../../http/config'
import { Query } from '../../../../../../responses/response'
import RequestDropdown from '../../../../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import Dropdown from '../../../../../data-components/dropdowns/Dropdown/Dropdown'

interface Props {
    open: boolean,
    config: RefLine[],
    filters: ProjectFiltersState,
    onChange: (value: Partial<ProjectFiltersState>) => void,
    objectStatusFilters?: boolean
}

const PopupFilters: FunctionComponent<Props> = props => {
    return <AnimatePresence>
    {
        props.open && <motion.div
            initial={{height: 0}}
            animate={{height: 'auto'}}
            exit={{height: 0}}
            style={{overflow: 'hidden'}}
        >
            <div className={styles.popup}>
                <DateRangeInput
                    placeholder={'Дата открытия'}
                    value={props.filters.openedAt}
                    onChange={openedAt => props.onChange({openedAt})}
                />
                {
                    props.config.map(config => {
                        const request = ({search, ...rest}: Query) => apiRequests.project.tip({
                            params: {key: config.key},
                            query: {query: search, ...rest}
                        })
                        const value = props.filters.dropdowns[config.key]
                        return config.multi?
                            <RequestDropdown
                                key={config.key}
                                type={'multi'}
                                placeholder={config.placeholder}
                                value={Array.isArray(value)? (value ?? []): []}
                                render={config.render}
                                request={request}
                                onChange={value => props.onChange({dropdowns: {
                                    ...props.filters.dropdowns, [config.key]: value}})}
                            />:
                            config.empty?
                                <RequestDropdown
                                    key={config.key}
                                    type={'nullable'}
                                    empty={config.empty}
                                    value={Array.isArray(value)? undefined: value}
                                    placeholder={config.placeholder}
                                    render={config.render}
                                    request={request}
                                    onChange={value => props.onChange({dropdowns: {
                                            ...props.filters.dropdowns, [config.key]: value}})}
                                />:
                                <RequestDropdown
                                    key={config.key}
                                    type={'single'}
                                    value={Array.isArray(value)? undefined: (value ?? undefined)}
                                    placeholder={config.placeholder}
                                    render={config.render}
                                    request={request}
                                    onChange={value => props.onChange({dropdowns: {
                                        ...props.filters.dropdowns, [config.key]: value}})}
                                />
                    })
                }
                {props.objectStatusFilters ? <><Dropdown
                    data={DesignProductionFilters}
                    selected={[props.filters.object_design_status]}
                    onClick={value => props.onChange({
                        ...props.filters.dropdowns,
                        object_design_status: props.filters.object_design_status === value ? undefined : value
                    })}
                    placeholder={'Статус по дизайну'}
                    render={item => item?.name ?? 'Статус по дизайну'}
                    toKey={item => item?.key ?? 0}
                    dropdownPlaceholder={true}
                    onClear={() => props.onChange({
                        ...props.filters.dropdowns,
                        object_design_status: null
                    })}
                /> <Dropdown
                    data={DesignProductionFilters}
                    selected={[props.filters.object_production_status]}
                    onClick={value => props.onChange({
                        ...props.filters.dropdowns,
                        object_production_status: props.filters.object_production_status === value ? undefined : value
                    })}
                    placeholder={'Статус по производству'}
                    render={item => item?.name ?? 'Статус по производству'}
                    toKey={item => item?.key ?? 0}
                    dropdownPlaceholder={true}
                    onClear={() => props.onChange({
                        ...props.filters.dropdowns,
                        object_production_status: null
                    })}
                />
                </>: ''}
                <div style={{
                    gridArea: '4 / 1 / 5 / 2',
                }}/>
            </div>
        </motion.div>
    }
</AnimatePresence>
}

export default PopupFilters